import debounce from 'debounce';

const data = () => ({
    store: $store,
    debounceTime: 500,
});

function created() {
    this.verifyAge = debounce(this.verifyAge, this.debounceTime);
}

async function verifyAge() {

    const [err, response] = await to(
        api.user.age_verification()
    );

    const url = _.get(response, 'data.url');

    if (err || !url) {
        return toastr.error(_.get(this, 'translate.home.errorCommon'));
    }

    window.location.href = url;

}

export default {
    data,
    created,
    computed: {
        ...mapState(['currentUser', 'translate']),
    },
    methods: {
        verifyAge,
    },

}
